import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { NoDataComponent, TwoGridSkeleton } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/common';
import { FormContainer, Separator } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/styles';
import { StyledTypography } from 'styles/common';

import { getParticipants } from 'services/engagement';
import { showErrorSnackbar } from 'services/snackbar';

const getDisplayData = (data) => {
  if (!data.selectedCohortId && !data.revieweesCount) {
    return [{ key: 'No participants selected for survey', value: '' }];
  }
  const selectedCohort =
    data.selectedCohortId && data.cohorts.filter((cohort) => cohort.id === data.selectedCohortId)[0];

  if (selectedCohort) {
    return [
      {
        key: `Selected Cohort: ${selectedCohort.name}`,
        value: `${data.revieweesCount} employee${data.revieweesCount !== 1 ? 's' : ''} selected`,
      },
    ];
  }
  return [
    {
      key: 'Employees CSV file uploaded',
      value: `${data.revieweesCount} employee${data.revieweesCount !== 1 ? 's' : ''} selected`,
    },
  ];
};

const ParticipantsSummary = ({ formId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = () => {
    getParticipants({ surveyId: formId })
      .then((res) => setData(res))
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to fetch the participants data!'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const displayData = data ? getDisplayData(data) : null;

  return (
    <FormContainer>
      <StyledTypography color="#333" weight={600}>
        Participants
      </StyledTypography>
      <Separator />
      {loading ? (
        <TwoGridSkeleton />
      ) : (
        <>
          {displayData ? (
            displayData.map((item, i) => (
              <>
                <Grid container>
                  <Grid xs={6}>
                    <StyledTypography color="#888">{item.key}</StyledTypography>
                  </Grid>
                  <Grid xs={6}>
                    <StyledTypography color="#333">{item.value}</StyledTypography>
                  </Grid>
                </Grid>
                {i < displayData.length - 1 && <Separator />}
              </>
            ))
          ) : (
            <NoDataComponent />
          )}
        </>
      )}
    </FormContainer>
  );
};

export default ParticipantsSummary;
